"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.as = exports.InlineType = exports.BlockType = void 0;
var BlockType;
(function (BlockType) {
    BlockType["Any"] = "any";
    BlockType["Paragraph"] = "paragraph";
    BlockType["Heading1"] = "heading1";
    BlockType["Heading2"] = "heading2";
    BlockType["HorizontalRule"] = "horizontalRule";
    BlockType["BlockQuote"] = "blockQuote";
    BlockType["ListItem"] = "listItem";
    BlockType["GoogleMaps"] = "googleMaps";
    BlockType["Image"] = "image";
    BlockType["Video"] = "video";
    BlockType["MediaVariable"] = "mediaVariable";
    BlockType["ContentLoop"] = "contentLoop";
    BlockType["ContentLoopBody"] = "contentLoopBody";
    BlockType["ContentLoopDummy"] = "contentLoopDummy";
    BlockType["Table"] = "table";
    BlockType["TableRow"] = "tableRow";
    BlockType["TableCell"] = "tableCell";
    BlockType["TableRepeatingRow"] = "tableRepeatingRow";
    BlockType["TableDummy"] = "tableDummy";
    BlockType["SideBySide"] = "sideBySide";
    BlockType["SideBySideColumn"] = "sideBySideColumn";
    BlockType["SideBySideDummy"] = "sideBySideDummy";
    BlockType["Caption"] = "caption";
    BlockType["Button"] = "button";
    BlockType["Iframe"] = "iframe";
    BlockType["ROICalculator"] = "roiCalculator";
    BlockType["Accordion"] = "accordion";
    BlockType["AccordionHeading"] = "accordionHeading";
    BlockType["AccordionBody"] = "accordionBody";
    BlockType["AccordionDummy"] = "accordionDummy";
})(BlockType || (BlockType = {}));
exports.BlockType = BlockType;
var InlineType;
(function (InlineType) {
    InlineType["Any"] = "any";
    InlineType["Link"] = "link";
    InlineType["Variable"] = "variable";
    InlineType["LineBreak"] = "lineBreak";
    InlineType["TokenWidget"] = "tokenWidget";
})(InlineType || (InlineType = {}));
exports.InlineType = InlineType;
function as(type, node) {
    if (node.type === type)
        return node;
    throw new Error("Type assertion error. Expected ".concat(type, " but was ").concat(node.type));
}
exports.as = as;
